import { z } from 'zod';
import { ProvisioningConsumablesFiltersValidator } from '../collators/schema';
import { validateHttpUrl } from '../utils/zod.utils';

export const HelpLinkValidator = z
  .object({
    label: z.string().trim().min(1),
    url: z.string().trim().min(1).superRefine(validateHttpUrl),
    icon: z.string().trim().min(1).optional(),
  })
  .strict();

export const HelpLinksValidator = z
  .object({
    items: z.array(HelpLinkValidator).optional(),
    adminItems: z.array(HelpLinkValidator).optional(),
  })
  .strict();

export const ConfigValidator = z.object({
  fe: z
    .object({
      helpLinks: HelpLinksValidator.optional(),
    })
    .optional(),
  search: z.object({
    'provisioning-consumables': z.object({
      filters: ProvisioningConsumablesFiltersValidator,
    }),
  }),
});

export type ConfigSchema = z.infer<typeof ConfigValidator>;

export const defaultConfig: DeepPartial<ConfigSchema> = {};

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};
